import { Box, Container } from "@mui/material";
import swal from "sweetalert";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./account.css";
import { theme } from "../../theme";
import { useEffect, useState } from "react";

function Setting() {
    const [setting, setSetting] = useState();
    const [load, setLoad] = useState(true);
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
                setLoad(false);
            });
        }
    }, [load]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            id: setting?._id,
            aff: 0,
            mb_lo2: Number(e.target.mb_lo2.value),
            mb_lo2dau: Number(e.target.mb_lo2dau.value),
            mb_lo3: Number(e.target.mb_lo3.value),
            mb_lo4: Number(e.target.mb_lo4.value),
            mb_loxien2: Number(e.target.mb_loxien2.value),
            mb_loxien3: Number(e.target.mb_loxien3.value),
            mb_loxien4: Number(e.target.mb_loxien4.value),
            mb_dedb: Number(e.target.mb_dedb.value),
            mb_dedaudb: Number(e.target.mb_dedaudb.value),
            mb_degiai7: Number(e.target.mb_degiai7.value),
            mb_de1: Number(e.target.mb_de1.value),
            mb_dedau1: Number(e.target.mb_dedau1.value),
            mb_dau: Number(e.target.mb_dau.value),
            mb_duoi: Number(e.target.mb_duoi.value),
            mb_3cangdau: Number(e.target.mb_3cangdau.value),
            mb_3cangdb: Number(e.target.mb_3cangdb.value),
            mb_3cang1: Number(e.target.mb_3cang1.value),
            mb_3cangdauduoi: Number(e.target.mb_3cangdauduoi.value),
            mb_4cangdb: Number(e.target.mb_4cangdb.value),
            mb_truotxien4: Number(e.target.mb_truotxien4.value),
            mb_truotxien8: Number(e.target.mb_truotxien8.value),
            mb_truotxien10: Number(e.target.mb_truotxien10.value),
            mb_lo2so1k: Number(e.target.mb_lo2so1k.value),
            mt_lo2: Number(e.target.mt_lo2.value),
            mt_lo2dau: Number(e.target.mt_lo2dau.value),
            mt_lo3: Number(e.target.mt_lo3.value),
            mt_lo4: Number(e.target.mt_lo4.value),
            mt_loxien2: Number(e.target.mt_loxien2.value),
            mt_loxien3: Number(e.target.mt_loxien3.value),
            mt_loxien4: Number(e.target.mt_loxien4.value),
            mt_dedb: Number(e.target.mt_dedb.value),
            mt_dedaudb: Number(e.target.mt_dedaudb.value),
            mt_degiai7: Number(e.target.mt_degiai7.value),
            mt_de1: Number(e.target.mt_de1.value),
            mt_dedau1: Number(e.target.mt_dedau1.value),
            mt_dedauduoi: Number(e.target.mt_dedauduoi.value),
            mt_dau: Number(e.target.mt_dau.value),
            mt_duoi: Number(e.target.mt_duoi.value),
            mt_3cangdau: Number(e.target.mt_3cangdau.value),
            mt_3cangdb: Number(e.target.mt_3cangdb.value),
            mt_3cang1: Number(e.target.mt_3cang1.value),
            mt_3cangdauduoi: Number(e.target.mt_3cangdauduoi.value),
            mt_4cangdb: Number(e.target.mt_4cangdb.value),
            mt_truotxien4: Number(e.target.mt_truotxien4.value),
            mt_truotxien8: Number(e.target.mt_truotxien8.value),
            mt_truotxien10: Number(e.target.mt_truotxien10.value),
            mt_lo2so1k: Number(e.target.mt_lo2so1k.value),
            mn_lo2: Number(e.target.mn_lo2.value),
            mn_lo2dau: Number(e.target.mn_lo2dau.value),
            mn_lo3: Number(e.target.mn_lo3.value),
            mn_lo4: Number(e.target.mn_lo4.value),
            mn_loxien2: Number(e.target.mn_loxien2.value),
            mn_loxien3: Number(e.target.mn_loxien3.value),
            mn_loxien4: Number(e.target.mn_loxien4.value),
            mn_dedb: Number(e.target.mn_dedb.value),
            mn_dedaudb: Number(e.target.mn_dedaudb.value),
            mn_degiai7: Number(e.target.mn_degiai7.value),
            mn_de1: Number(e.target.mn_de1.value),
            mn_dedau1: Number(e.target.mn_dedau1.value),
            mn_dedauduoi: Number(e.target.mn_dedauduoi.value),
            mn_dau: Number(e.target.mn_dau.value),
            mn_duoi: Number(e.target.mn_duoi.value),
            mn_3cangdau: Number(e.target.mn_3cangdau.value),
            mn_3cangdb: Number(e.target.mn_3cangdb.value),
            mn_3cang1: Number(e.target.mn_3cang1.value),
            mn_3cangdauduoi: Number(e.target.mn_3cangdauduoi.value),
            mn_4cangdb: Number(e.target.mn_4cangdb.value),
            mn_truotxien4: Number(e.target.mn_truotxien4.value),
            mn_truotxien8: Number(e.target.mn_truotxien8.value),
            mn_truotxien10: Number(e.target.mn_truotxien10.value),
            mn_lo2so1k: Number(e.target.mn_lo2so1k.value)
        };
        console.log(formData);
        axios
            .put(`${process.env.REACT_APP_API_URL}/setting/update`, formData)
            .then((res) => {
                setLoad(true);
                swal("Sửa thông tin trò chơi thành công!");
            })
            .catch((res) => setLoad(true));
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 8
                            }}>
                            <Container maxWidth={false}>
                                <div style={{ fontSize: "25px", fontWeight: 700 }}>Cài đặt trả thưởng</div>
                                <div style={{ marginTop: "20px" }}>
                                    <form className="setting" onSubmit={handleSubmit}>
                                        <h3
                                            style={{
                                                width: "100%",
                                                flex: "0 0 100%",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                margin: "30px 10px 10px"
                                            }}>
                                            Miền Bắc
                                        </h3>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số</label>
                                                <input defaultValue={setting?.mb_lo2} type="number" name="mb_lo2" step="any" id="mb_lo2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số 1K</label>
                                                <input defaultValue={setting?.mb_lo2so1k} type="number" name="mb_lo2so1k" step="any" id="mb_lo2so1k" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số đầu</label>
                                                <input defaultValue={setting?.mb_lo2dau} type="number" name="mb_lo2dau" step="any" id="mb_lo2dau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 3 số</label>
                                                <input defaultValue={setting?.mb_lo3} type="number" name="mb_lo3" step="any" id="mb_lo3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 4 số</label>
                                                <input defaultValue={setting?.mb_lo4} type="number" name="mb_lo4" step="any" id="mb_lo4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 2</label>
                                                <input defaultValue={setting?.mb_loxien2} type="number" name="mb_loxien2" step="any" id="mb_loxien2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 3</label>
                                                <input defaultValue={setting?.mb_loxien3} type="number" name="mb_loxien3" step="any" id="mb_loxien3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 4</label>
                                                <input defaultValue={setting?.mb_loxien4} type="number" name="mb_loxien4" step="any" id="mb_loxien4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đặc biệt</label>
                                                <input defaultValue={setting?.mb_dedb} type="number" name="mb_dedb" step="any" id="mb_dedb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu đặc biệt</label>
                                                <input defaultValue={setting?.mb_dedaudb} type="number" name="mb_dedaudb" step="any" id="mb_dedaudb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề giải 7</label>
                                                <input defaultValue={setting?.mb_degiai7} type="number" name="mb_degiai7" step="any" id="mb_degiai7" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề giải nhất</label>
                                                <input defaultValue={setting?.mb_de1} type="number" name="mb_de1" step="any" id="mb_de1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu giải nhất</label>
                                                <input defaultValue={setting?.mb_dedau1} type="number" name="mb_dedau1" step="any" id="mb_dedau1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đầu</label>
                                                <input defaultValue={setting?.mb_dau} type="number" name="mb_dau" step="any" id="mb_dau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đuôi</label>
                                                <input defaultValue={setting?.mb_duoi} type="number" name="mb_duoi" step="any" id="mb_duoi" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đầu</label>
                                                <input defaultValue={setting?.mb_3cangdau} type="number" name="mb_3cangdau" step="any" id="mb_3cangdau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đặc biệt</label>
                                                <input defaultValue={setting?.mb_3cangdb} type="number" name="mb_3cangdb" step="any" id="mb_3cangdb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng giải nhất</label>
                                                <input defaultValue={setting?.mb_3cang1} type="number" name="mb_3cang1" step="any" id="mb_3cang1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đầu đuôi</label>
                                                <input
                                                    defaultValue={setting?.mb_3cangdauduoi}
                                                    type="number"
                                                    name="mb_3cangdauduoi"
                                                    step="any"
                                                    id="mb_3cangdauduoi"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>4 càng đặc biệt</label>
                                                <input defaultValue={setting?.mb_4cangdb} type="number" name="mb_4cangdb" step="any" id="mb_4cangdb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 4</label>
                                                <input
                                                    defaultValue={setting?.mb_truotxien4}
                                                    type="number"
                                                    name="mb_truotxien4"
                                                    step="any"
                                                    id="mb_truotxien4"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 8</label>
                                                <input
                                                    defaultValue={setting?.mb_truotxien8}
                                                    type="number"
                                                    name="mb_truotxien8"
                                                    step="any"
                                                    id="mb_truotxien8"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 10</label>
                                                <input
                                                    defaultValue={setting?.mb_truotxien10}
                                                    type="number"
                                                    name="mb_truotxien10"
                                                    step="any"
                                                    id="mb_truotxien10"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <h3
                                            style={{
                                                width: "100%",
                                                flex: "0 0 100%",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                margin: "30px 10px 10px"
                                            }}>
                                            Miền Nam
                                        </h3>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số</label>
                                                <input defaultValue={setting?.mn_lo2} type="number" name="mn_lo2" step="any" id="mn_lo2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số 1K</label>
                                                <input defaultValue={setting?.mn_lo2so1k} type="number" name="mn_lo2so1k" step="any" id="mn_lo2so1k" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số đầu</label>
                                                <input defaultValue={setting?.mn_lo2dau} type="number" name="mn_lo2dau" step="any" id="mn_lo2dau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 3 số</label>
                                                <input defaultValue={setting?.mn_lo3} type="number" name="mn_lo3" step="any" id="mn_lo3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 4 số</label>
                                                <input defaultValue={setting?.mn_lo4} type="number" name="mn_lo4" step="any" id="mn_lo4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 2</label>
                                                <input defaultValue={setting?.mn_loxien2} type="number" name="mn_loxien2" step="any" id="mn_loxien2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 3</label>
                                                <input defaultValue={setting?.mn_loxien3} type="number" name="mn_loxien3" step="any" id="mn_loxien3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 4</label>
                                                <input defaultValue={setting?.mn_loxien4} type="number" name="mn_loxien4" step="any" id="mn_loxien4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đặc biệt</label>
                                                <input defaultValue={setting?.mn_dedb} type="number" name="mn_dedb" step="any" id="mn_dedb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu đặc biệt</label>
                                                <input defaultValue={setting?.mn_dedaudb} type="number" name="mn_dedaudb" step="any" id="mn_dedaudb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề giải 7</label>
                                                <input defaultValue={setting?.mn_degiai7} type="number" name="mn_degiai7" step="any" id="mn_degiai7" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề giải nhất</label>
                                                <input defaultValue={setting?.mn_de1} type="number" name="mn_de1" step="any" id="mn_de1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu giải nhất</label>
                                                <input defaultValue={setting?.mn_dedau1} type="number" name="mn_dedau1" step="any" id="mn_dedau1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu đuôi</label>
                                                <input
                                                    defaultValue={setting?.mn_dedauduoi}
                                                    type="number"
                                                    name="mn_dedauduoi"
                                                    step="any"
                                                    id="mn_dedauduoi"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đầu</label>
                                                <input defaultValue={setting?.mn_dau} type="number" name="mn_dau" step="any" id="mn_dau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đuôi</label>
                                                <input defaultValue={setting?.mn_duoi} type="number" name="mn_duoi" step="any" id="mn_duoi" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đầu</label>
                                                <input defaultValue={setting?.mn_3cangdau} type="number" name="mn_3cangdau" step="any" id="mn_3cangdau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đặc biệt</label>
                                                <input defaultValue={setting?.mn_3cangdb} type="number" name="mn_3cangdb" step="any" id="mn_3cangdb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng giải nhất</label>
                                                <input defaultValue={setting?.mn_3cang1} type="number" name="mn_3cang1" step="any" id="mn_3cang1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đầu đuôi</label>
                                                <input
                                                    defaultValue={setting?.mn_3cangdauduoi}
                                                    type="number"
                                                    name="mn_3cangdauduoi"
                                                    step="any"
                                                    id="mn_3cangdauduoi"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>4 càng đặc biệt</label>
                                                <input defaultValue={setting?.mn_4cangdb} type="number" name="mn_4cangdb" step="any" id="mn_4cangdb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 4</label>
                                                <input
                                                    defaultValue={setting?.mn_truotxien4}
                                                    type="number"
                                                    name="mn_truotxien4"
                                                    step="any"
                                                    id="mn_truotxien4"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 8</label>
                                                <input
                                                    defaultValue={setting?.mn_truotxien8}
                                                    type="number"
                                                    name="mn_truotxien8"
                                                    step="any"
                                                    id="mn_truotxien8"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 10</label>
                                                <input
                                                    defaultValue={setting?.mn_truotxien10}
                                                    type="number"
                                                    name="mn_truotxien10"
                                                    step="any"
                                                    id="mn_truotxien10"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <h3
                                            style={{
                                                width: "100%",
                                                flex: "0 0 100%",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                margin: "30px 10px 10px"
                                            }}>
                                            Miền Trung
                                        </h3>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số</label>
                                                <input defaultValue={setting?.mt_lo2} type="number" name="mt_lo2" step="any" id="mt_lo2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số 1K</label>
                                                <input defaultValue={setting?.mt_lo2so1k} type="number" name="mt_lo2so1k" step="any" id="mt_lo2so1k" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 2 số đầu</label>
                                                <input defaultValue={setting?.mt_lo2dau} type="number" name="mt_lo2dau" step="any" id="mt_lo2dau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 3 số</label>
                                                <input defaultValue={setting?.mt_lo3} type="number" name="mt_lo3" step="any" id="mt_lo3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô 4 số</label>
                                                <input defaultValue={setting?.mt_lo4} type="number" name="mt_lo4" step="any" id="mt_lo4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 2</label>
                                                <input defaultValue={setting?.mt_loxien2} type="number" name="mt_loxien2" step="any" id="mt_loxien2" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 3</label>
                                                <input defaultValue={setting?.mt_loxien3} type="number" name="mt_loxien3" step="any" id="mt_loxien3" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Lô xiên 4</label>
                                                <input defaultValue={setting?.mt_loxien4} type="number" name="mt_loxien4" step="any" id="mt_loxien4" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đặc biệt</label>
                                                <input defaultValue={setting?.mt_dedb} type="number" name="mt_dedb" step="any" id="mt_dedb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu đặc biệt</label>
                                                <input defaultValue={setting?.mt_dedaudb} type="number" name="mt_dedaudb" step="any" id="mt_dedaudb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề giải 7</label>
                                                <input defaultValue={setting?.mt_degiai7} type="number" name="mt_degiai7" step="any" id="mt_degiai7" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề giải nhất</label>
                                                <input defaultValue={setting?.mt_de1} type="number" name="mt_de1" step="any" id="mt_de1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu giải nhất</label>
                                                <input defaultValue={setting?.mt_dedau1} type="number" name="mt_dedau1" step="any" id="mt_dedau1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đề đầu đuôi</label>
                                                <input
                                                    defaultValue={setting?.mt_dedauduoi}
                                                    type="number"
                                                    name="mt_dedauduoi"
                                                    step="any"
                                                    id="mt_dedauduoi"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đầu</label>
                                                <input defaultValue={setting?.mt_dau} type="number" name="mt_dau" step="any" id="mt_dau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Đuôi</label>
                                                <input defaultValue={setting?.mt_duoi} type="number" name="mt_duoi" step="any" id="mt_duoi" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đầu</label>
                                                <input defaultValue={setting?.mt_3cangdau} type="number" name="mt_3cangdau" step="any" id="mt_3cangdau" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đặc biệt</label>
                                                <input defaultValue={setting?.mt_3cangdb} type="number" name="mt_3cangdb" step="any" id="mt_3cangdb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng giải nhất</label>
                                                <input defaultValue={setting?.mt_3cang1} type="number" name="mt_3cang1" step="any" id="mt_3cang1" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>3 càng đầu đuôi</label>
                                                <input
                                                    defaultValue={setting?.mt_3cangdauduoi}
                                                    type="number"
                                                    name="mt_3cangdauduoi"
                                                    step="any"
                                                    id="mt_3cangdauduoi"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>4 càng đặc biệt</label>
                                                <input defaultValue={setting?.mt_4cangdb} type="number" name="mt_4cangdb" step="any" id="mt_4cangdb" className="input_setting" />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 4</label>
                                                <input
                                                    defaultValue={setting?.mt_truotxien4}
                                                    type="number"
                                                    name="mt_truotxien4"
                                                    step="any"
                                                    id="mt_truotxien4"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 8</label>
                                                <input
                                                    defaultValue={setting?.mt_truotxien8}
                                                    type="number"
                                                    name="mt_truotxien8"
                                                    step="any"
                                                    id="mt_truotxien8"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col">
                                            <div className="form_group">
                                                <label>Trượt xiên 10</label>
                                                <input
                                                    defaultValue={setting?.mt_truotxien10}
                                                    type="number"
                                                    name="mt_truotxien10"
                                                    step="any"
                                                    id="mt_truotxien10"
                                                    className="input_setting"
                                                />
                                            </div>
                                        </div>
                                        <div className="form_col" style={{ clear: "both", width: "100%" }}>
                                            <button type="submit" className="btn_setting">
                                                Lưu
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </Container>
                        </Box>
                    }
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default Setting;
